import { render } from "./HomeComponent.vue?vue&type=template&id=f5d12aec&scoped=true&ts=true"
import script from "./HomeComponent.vue?vue&type=script&lang=ts"
export * from "./HomeComponent.vue?vue&type=script&lang=ts"

import "./HomeComponent.vue?vue&type=style&index=0&id=f5d12aec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d12aec"]])

export default __exports__